import React, { useState, useEffect, useRef, } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../assets/css/Navigation.css";
import ViewAll from "./ViewAll";
import AddWishlist from "./component/CartWishlist";
import CartWishlist from "./component/CartWishlist";
import DropDownProfile from "./component/DropDownProfile";
import AddtoCart from "./component/AddtoCart";
import EventAddtoCart from "./component/EventAddtoCart";
import { getMenuService } from "./service/MenuService";

const Navigationbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [setMenuOpen] = useState(false);
  const [bathCareOpen, setBathCareOpen] = useState(false);
  const [dustbinsOpen, setDustbinsOpen] = useState(false);
  const [floorCoveringOpen, setFloorCoveringOpen] = useState(false);
  const [homeDecorOpen, setHomeDecorOpen] = useState(false);
  const [kitchenOpen, setKitchenOpen] = useState(false);
  const [organisersOpen, setOrganisersOpen] = useState(false);
  const [tablewareOpen, settablewareOpen] = useState(false);
  const [yogamatOpen, setyogamatOpen] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  const [searchText, setSearchText] = useState({});
  const handleSearchChange = (slug, value) => {
  setSearchText((prev) => ({
    ...prev,
    [slug]: value,
  }));
};
  
const [megaMenu, setMegaMenu] = useState([]);
      useEffect(() => {
        loadMenu();
      }, []);
      const loadMenu = async () => {
    try {
      const cachedMenu = localStorage.getItem("megaMenu");
    if (cachedMenu) {
      setMegaMenu(JSON.parse(cachedMenu));
    }
    const menu = await getMenuService();
    if (menu && menu.length > 0) {
      setMegaMenu(menu);
      localStorage.setItem(
        "megaMenu",
        JSON.stringify(menu)
      );
    }
  } catch (error) {
    console.error("Menu loading error:", error);
  }
  };
      
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992); // md breakpoint
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = () => {
    if (!isMobile) setShowDropdown(true);
  };
  const handleMouseLeave = () => {
    if (!isMobile) setShowDropdown(false);
  };
  const handleClick = () => {
    if (isMobile) setShowDropdown((prev) => !prev);
  };

  return (
    <>
    <Navbar expand="lg" className="bg-Dark">
      <Container>
        <Navbar.Brand className="navbar-brand-box">
          <Link to="/">
          <img
            src="https://b2b.obsessions.co.in/public/design/img/white-logo.png" className="logo-Responsive-Obsessions"
            alt="Logo"
          />
          </Link>
        </Navbar.Brand>
        {isMobile ? (
          <div className="hamburger" onClick={() => setMenuOpen(true)}>
            &#9776;
          </div>
        ) : (

      <Nav className="ms-right desktop-menu">
        {megaMenu.map((category) => (
          <NavDropdown
        key={category.category_slug}
        title={category.category_name}
        id={category.category_slug}
        show={showDropdown === category.category_slug}
        onMouseEnter={() => {
          if (!isMobile) {
            setShowDropdown(category.category_slug);
          }
        }}
        onMouseLeave={() => {
          if (!isMobile) {
            setShowDropdown(false);
          }
        }}
        onClick={(e) => {
          if (!isMobile) {
            e.preventDefault(); // click disable
          }
        }}
      >
            {category.subcategories
              ?.filter((sub) => sub.subcategory_name)
              .map((sub) => (
                <div
                  className="dropdown-submenu"
                  key={sub.subcategory_slug}
                >
                  <NavDropdown.Item className="submenu-toggle">
                    {sub.subcategory_name}
                    {sub.qualities?.length > 0 && (
                      <span className="RightArrow">
                        <i className="bi bi-chevron-right"></i>
                      </span>
                    )}

                  </NavDropdown.Item>
  
  {
  ["bath-mat", "bath-set", "carpet", "runner"].includes(sub.subcategory_slug) &&
  sub.qualities?.length > 0 && (
  <div className="submenu widthIncrese">
    <div className="searchboxNav">
      <input
        type="text"
        placeholder="Search"
        className="searchinput"
        value={searchText[sub.subcategory_slug] || ""}
        onChange={(e) =>
          handleSearchChange(
            sub.subcategory_slug,
            e.target.value
          )
        }
      />
      <span className="searchicons">
        <i className="bi bi-search"></i>
      </span>
    </div>
    {
      (() => {
        const filteredQualities = sub.qualities.filter((quality) =>
          quality.quality_name
            .toLowerCase()
            .includes(
              (searchText[sub.subcategory_slug] || "")
                .toLowerCase()
            )
        );
        return (
          <div className="row">
            {/* Column 1 */}
            <div className="col-md-4">
              {
                filteredQualities
                  .slice(0,10)
                  .map((quality)=>(
                    <NavDropdown.Item
                      key={quality.quality_action_link}
                      as={Link}
                      to={`/products/${quality.quality_action_link}`}
                      style={{
                        color:"#fff",
                        whiteSpace:"normal",
                        wordBreak:"break-word"
                      }}
                    >
                      {quality.quality_name}
                    </NavDropdown.Item>
                  ))
              }
            </div>

            {/* Column 2 */}

            <div className="col-md-4">
              {
                filteredQualities
                  .slice(10,20)
                  .map((quality)=>(
                    
                    <NavDropdown.Item
                      key={quality.quality_action_link}
                      as={Link}
                      to={`/products/${quality.quality_action_link}`}
                      style={{
                        color:"#fff",
                        whiteSpace:"normal",
                        wordBreak:"break-word"
                      }}
                    >
                      {quality.quality_name}
                    </NavDropdown.Item>
                  ))
              }
            </div>

            {/* Column 3 */}

            <div className="col-md-4">
              {
                filteredQualities
                  .slice(20,30)
                  .map((quality)=>(
                  
                    <NavDropdown.Item
                      key={quality.quality_action_link}
                      as={Link}
                      to={`/products/${quality.quality_action_link}`}
                      style={{
                        color:"#fff",
                        whiteSpace:"normal",
                        wordBreak:"break-word"
                      }}
                    >
                      {quality.quality_name}
                    </NavDropdown.Item>
                  ))
              }
            </div>
            {
              filteredQualities.length > 30 && (
                <div className="col-md-12 text-right">
                  <ViewAll data={filteredQualities}/>
                </div>
              )
            }
          </div>
        );
      })()
    }
  </div>
)
}

      {/* Normal Subcategory Menu */}

      {!["bath-mat", "bath-set", "carpet", "runner"].includes(sub.subcategory_slug) &&
        sub.qualities?.length > 0 && (
        <div className="submenu">
          {sub.qualities.map((quality) => (
            <NavDropdown.Item
              key={quality.quality_action_link}
              as={Link}
              to={`/products/${quality.quality_action_link}`}
             >
              {quality.quality_name}
            </NavDropdown.Item>
          ))}
        </div>
      )}
        </div>
      ))}
        </NavDropdown>
        ))}
      </Nav>
     )}
        <Navbar.Brand>
          {/* addcart wishlist */}
          <div className="Wishlist-with-login d-none-mobile">
            <> 
             <CartWishlist/>
             <AddtoCart/>
             {/* <EventAddtoCart/> */}
             <DropDownProfile
                dropdownRef={dropdownRef}
                handleMouseEnter={() => setShowProfileDropdown(true)}
                handleMouseLeave={() => setShowProfileDropdown(false)}
                handleClick={() => setShowProfileDropdown(prev => !prev)}
                showDropdown={showProfileDropdown}
                Link={Link}
              />
            </>
          </div>
        </Navbar.Brand>
    </Container>
    </Navbar>
 </>
  );
};
export default Navigationbar;